/*
  Isekaid Black Rune Cursor
  File: assets/isekaid-rune-cursor.js
*/

(() => {
  const finePointer = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (!finePointer.matches || reducedMotion.matches) {
    return;
  }

  document
    .querySelector('.isekaid-rune-cursor')
    ?.remove();

  const cursor = document.createElement('div');

  cursor.className = 'isekaid-rune-cursor';
  cursor.setAttribute('aria-hidden', 'true');

  cursor.innerHTML = `
    <div class="isekaid-rune-cursor__circle">
      <svg
        class="isekaid-rune-cursor__circle-svg"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="32"
          cy="32"
          r="27"
          fill="rgba(0, 0, 0, 0.14)"
          stroke="#FFFFFF"
          stroke-width="1"
          opacity="0.9"
        />

        <circle
          cx="32"
          cy="32"
          r="22.5"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="0.65"
          opacity="0.55"
        />

        <g
          class="isekaid-rune-cursor__outer-runes"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
          opacity="0.9"
        >
          <path d="M32 3 L29.5 7 L34.5 7 Z" />
          <path d="M32 61 L29.5 57 L34.5 57 Z" />
          <path d="M3 32 L7 29.5 L7 34.5 Z" />
          <path d="M61 32 L57 29.5 L57 34.5 Z" />

          <path d="M11 11 L15 12 L12 16" />
          <path d="M53 11 L49 12 L52 16" />
          <path d="M11 53 L15 52 L12 48" />
          <path d="M53 53 L49 52 L52 48" />

          <path d="M19 5.5 L22 9.5 L18 10 Z" />
          <path d="M45 5.5 L42 9.5 L46 10 Z" />
          <path d="M19 58.5 L22 54.5 L18 54 Z" />
          <path d="M45 58.5 L42 54.5 L46 54 Z" />

          <path d="M5.5 19 L9.5 22 L10 18 Z" />
          <path d="M58.5 19 L54.5 22 L54 18 Z" />
          <path d="M5.5 45 L9.5 42 L10 46 Z" />
          <path d="M58.5 45 L54.5 42 L54 46 Z" />
        </g>

        <g
          class="isekaid-rune-cursor__inner-runes"
          fill="none"
          stroke="#FFFFFF"
          stroke-width="1.1"
          stroke-linecap="round"
          stroke-linejoin="round"
          opacity="0.84"
        >
          <path
            d="M32 32 L32 13 M29 17 L32 13 L35 17"
          />

          <path
            d="
              M32 32
              L45.5 18.5
              M41 19
              L45.5 18.5
              L45 23
            "
          />

          <path
            d="M32 32 L51 32 M47 29 L51 32 L47 35"
          />

          <path
            d="
              M32 32
              L45.5 45.5
              M45 41
              L45.5 45.5
              L41 45
            "
          />

          <path
            d="M32 32 L32 51 M29 47 L32 51 L35 47"
          />

          <path
            d="
              M32 32
              L18.5 45.5
              M23 45
              L18.5 45.5
              L19 41
            "
          />

          <path
            d="M32 32 L13 32 M17 29 L13 32 L17 35"
          />

          <path
            d="
              M32 32
              L18.5 18.5
              M19 23
              L18.5 18.5
              L23 19
            "
          />
        </g>

        <circle
          cx="32"
          cy="32"
          r="5.2"
          fill="#050505"
          stroke="#FFFFFF"
          stroke-width="0.9"
        />

        <circle
          cx="32"
          cy="32"
          r="1.8"
          fill="#FFFFFF"
        />
      </svg>
    </div>

    <div class="isekaid-rune-cursor__pointer">
      <svg
        class="isekaid-rune-cursor__arrow"
        viewBox="0 0 24 31"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="
            M2.5 2
            L19.5 17.5
            L13.1 18.4
            L17 27.3
            L12.8 29
            L9.1 20.1
            L4.5 24.4
            Z
          "
          fill="#050505"
          stroke="#FFFFFF"
          stroke-width="1.45"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        class="isekaid-rune-cursor__hand"
        viewBox="0 0 27 34"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="
            M10.2 3.2

            C10.2 1.9 11.1 1 12.3 1
            C13.6 1 14.4 2 14.4 3.3

            V12.2

            C14.4 10.8 15.3 9.9 16.5 9.9
            C17.8 9.9 18.6 10.9 18.6 12.2

            V13.2

            C18.6 11.9 19.5 11 20.7 11
            C22 11 22.8 12 22.8 13.3

            V14.5

            C22.8 13.3 23.7 12.5 24.8 12.5
            C26.1 12.5 26.8 13.5 26.7 14.8

            L26.1 22.4

            C25.8 27.3 22.3 32.2 16.3 32.7
            C10.4 33.2 6.3 29.6 4.5 25.3

            L1.5 18.4

            C0.9 17 1.4 15.7 2.6 15.1
            C3.8 14.5 5 15 5.8 16.2

            L10.2 21.3

            Z
          "
          fill="#050505"
          stroke="#FFFFFF"
          stroke-width="1.45"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="isekaid-rune-cursor__click-pulse"></div>
  `;

  const style = document.createElement('style');

  style.textContent = `
    @media (hover: hover) and (pointer: fine) {
      html.isekaid-rune-cursor-ready,
      html.isekaid-rune-cursor-ready body,
      html.isekaid-rune-cursor-ready body * {
        cursor: none !important;
      }

      .isekaid-rune-cursor {
        position: fixed !important;

        top: 0 !important;
        left: 0 !important;
        right: auto !important;
        bottom: auto !important;

        width: 0 !important;
        height: 0 !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;

        z-index: 2147483647 !important;
        pointer-events: none !important;

        opacity: 0;
        visibility: hidden;

        transform:
          translate3d(-100px, -100px, 0);

        transition:
          opacity 100ms ease,
          visibility 100ms ease !important;

        will-change: transform;
      }

      .isekaid-rune-cursor.is-visible {
        opacity: 1;
        visibility: visible;
      }

      /*
        No width or height is assigned here.

        The existing theme stylesheet keeps the rune
        circle at its original preferred size.
      */
      .isekaid-rune-cursor__circle {
        position: absolute !important;

        top: 0 !important;
        left: 0 !important;

        margin: 0 !important;
        padding: 0 !important;

        pointer-events: none !important;

        transform:
          translate(-50%, -50%) !important;

        transform-origin:
          center center !important;
      }

      .isekaid-rune-cursor__circle-svg {
        display: block !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;
      }

      /*
        This wrapper is anchored to the same exact
        coordinate as the rune's center.
      */
      .isekaid-rune-cursor__pointer {
        position: absolute !important;

        top: 0 !important;
        left: 0 !important;

        width: 0 !important;
        height: 0 !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;

        opacity: 1 !important;
        visibility: visible !important;

        transform: none !important;

        pointer-events: none !important;
        z-index: 10 !important;
      }

      .isekaid-rune-cursor__arrow,
      .isekaid-rune-cursor__hand {
        position: absolute !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: visible !important;

        opacity: 1 !important;
        visibility: visible !important;

        pointer-events: none !important;

        filter:
          drop-shadow(
            0 0 1px
            rgba(255, 255, 255, 1)
          )
          drop-shadow(
            0 0 4px
            rgba(255, 255, 255, 0.78)
          )
          drop-shadow(
            0 0 8px
            rgba(255, 255, 255, 0.34)
          ) !important;
      }

      /*
        The pointed tip is placed directly on
        the center of the rune circle.
      */
      .isekaid-rune-cursor__arrow {
        display: block !important;

        top: -1.5px !important;
        left: -1.9px !important;

        width: 18px !important;
        height: 23.25px !important;

        max-width: none !important;
        max-height: none !important;

        transform: none !important;
      }

      /*
        The index fingertip is placed directly on
        the center of the rune circle.
      */
      .isekaid-rune-cursor__hand {
        display: none !important;

        top: -0.7px !important;
        left: -8.65px !important;

        width: 19px !important;
        height: 23.93px !important;

        max-width: none !important;
        max-height: none !important;

        transform: none !important;
      }

      .isekaid-rune-cursor.is-interactive
        .isekaid-rune-cursor__arrow {
        display: none !important;
      }

      .isekaid-rune-cursor.is-interactive
        .isekaid-rune-cursor__hand {
        display: block !important;
      }

      .isekaid-rune-cursor.is-clicking
        .isekaid-rune-cursor__circle {
        transform:
          translate(-50%, -50%)
          scale(0.9) !important;
      }

      .isekaid-rune-cursor__click-pulse {
        position: absolute !important;

        top: 0 !important;
        left: 0 !important;

        width: 10px;
        height: 10px;

        border:
          1px solid
          rgba(255, 255, 255, 0.8);

        border-radius: 50%;

        pointer-events: none;

        opacity: 0;

        transform:
          translate(-50%, -50%)
          scale(0.5);
      }

      .isekaid-rune-cursor__click-pulse.is-active {
        animation:
          isekaidRuneCursorPulse
          420ms
          ease-out
          forwards;
      }

      @keyframes isekaidRuneCursorPulse {
        0% {
          opacity: 0.85;

          transform:
            translate(-50%, -50%)
            scale(0.5);
        }

        100% {
          opacity: 0;

          transform:
            translate(-50%, -50%)
            scale(4);
        }
      }
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(cursor);

  const clickPulse = cursor.querySelector(
    '.isekaid-rune-cursor__click-pulse'
  );

  const interactiveSelector = [
    'a',
    'button',
    'summary',
    'label[for]',
    'select',

    '[role="button"]',
    '[role="link"]',
    '[onclick]',
    '[tabindex]:not([tabindex="-1"])',

    'input[type="submit"]',
    'input[type="button"]',
    'input[type="checkbox"]',
    'input[type="radio"]',

    '.button',
    '.btn',
    '.button-secondary',

    '.shopify-payment-button__button',

    '.isekaid-hotspot',
    '.product-card',
    '.card-wrapper',
    '.isekaid-creator-card',
    '.isekaid-hotspots__detail-link',

    '[data-add-to-cart]',
    '[data-cart-toggle]',
    '[data-search-toggle]',
    '[data-modal-open]',
    '[data-drawer-open]',
    '[data-product-form]',
    '[data-quick-add]',

    'product-card',
    'product-form',
    'cart-remove-button',

    '.header__icon',
    '.header-actions__action',

    '.cart-drawer__close',
    '.drawer__close',
    '.modal__close',

    '.predictive-search__item',
    '.quick-add__submit'
  ].join(',');

  let pointerX = -100;
  let pointerY = -100;
  let clickTimer = null;

  /*
    Direct positioning only.

    No interpolation, requestAnimationFrame,
    smoothing or trailing animation.
  */
  /*
  Native Shopify dialogs enter the browser's top layer.
  The rune cursor must live inside the currently open
  dialog to remain visible above it.
*/
const getCursorHost = () => {
  const openDialogs = Array.from(
    document.querySelectorAll('dialog[open]')
  ).filter((dialog) => {
    const styles = window.getComputedStyle(dialog);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden'
    );
  });

  return (
    openDialogs[openDialogs.length - 1] ||
    document.body
  );
};

const moveCursor = (x, y) => {
  const desiredHost = getCursorHost();

  if (cursor.parentElement !== desiredHost) {
    desiredHost.appendChild(cursor);
  }

  /*
    Dialog drawers often use transforms. Inside a dialog,
    absolute positioning with dialog-relative coordinates
    prevents the cursor from being offset.
  */
  if (desiredHost instanceof HTMLDialogElement) {
    const rect =
      desiredHost.getBoundingClientRect();

    const localX =
      x -
      rect.left -
      desiredHost.clientLeft +
      desiredHost.scrollLeft;

    const localY =
      y -
      rect.top -
      desiredHost.clientTop +
      desiredHost.scrollTop;

    cursor.style.setProperty(
      'position',
      'absolute',
      'important'
    );

    cursor.style.transform =
      `translate3d(${localX}px, ${localY}px, 0)`;

    return;
  }

  cursor.style.setProperty(
    'position',
    'fixed',
    'important'
  );

  cursor.style.transform =
    `translate3d(${x}px, ${y}px, 0)`;
};

const syncCursorHost = () => {
  const desiredHost = getCursorHost();

  if (cursor.parentElement !== desiredHost) {
    desiredHost.appendChild(cursor);
  }

  if (
    pointerX >= 0 &&
    pointerY >= 0
  ) {
    moveCursor(
      pointerX,
      pointerY
    );
  }
};

  const updateInteractiveState = (target) => {
    const element =
      target instanceof Element
        ? target
        : null;

    cursor.classList.toggle(
      'is-interactive',
      Boolean(
        element?.closest(
          interactiveSelector
        )
      )
    );
  };

  const showCursor = () => {
    cursor.classList.add(
      'is-visible'
    );
  };

  const hideCursor = () => {
    cursor.classList.remove(
      'is-visible',
      'is-interactive',
      'is-clicking'
    );
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      if (
        event.pointerType &&
        event.pointerType !== 'mouse'
      ) {
        return;
      }

      pointerX = event.clientX;
      pointerY = event.clientY;

      moveCursor(
        pointerX,
        pointerY
      );

      updateInteractiveState(
        event.target
      );

      showCursor();
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    'pointerover',
    (event) => {
      if (
        event.pointerType &&
        event.pointerType !== 'mouse'
      ) {
        return;
      }

      updateInteractiveState(
        event.target
      );
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (
        event.pointerType &&
        event.pointerType !== 'mouse'
      ) {
        return;
      }

      pointerX = event.clientX;
      pointerY = event.clientY;

      moveCursor(
        pointerX,
        pointerY
      );

      cursor.classList.add(
        'is-clicking'
      );

      if (clickPulse) {
        clickPulse.classList.remove(
          'is-active'
        );

        void clickPulse.offsetWidth;

        clickPulse.classList.add(
          'is-active'
        );
      }

      window.clearTimeout(
        clickTimer
      );

      clickTimer = window.setTimeout(
        () => {
          cursor.classList.remove(
            'is-clicking'
          );
        },
        170
      );
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    'pointerup',
    () => {
      window.clearTimeout(
        clickTimer
      );

      clickTimer = window.setTimeout(
        () => {
          cursor.classList.remove(
            'is-clicking'
          );
        },
        70
      );
    },
    {
      passive: true,
      capture: true
    }
  );

  clickPulse?.addEventListener(
    'animationend',
    () => {
      clickPulse.classList.remove(
        'is-active'
      );
    }
  );

  document.addEventListener(
    'mouseleave',
    hideCursor
  );

  document.addEventListener(
    'mouseenter',
    () => {
      if (
        pointerX < 0 ||
        pointerY < 0
      ) {
        return;
      }

      moveCursor(
        pointerX,
        pointerY
      );

      showCursor();
    }
  );

  window.addEventListener(
    'blur',
    hideCursor
  );

  window.addEventListener(
    'focus',
    () => {
      if (
        pointerX < 0 ||
        pointerY < 0
      ) {
        return;
      }

      moveCursor(
        pointerX,
        pointerY
      );

      showCursor();
    }
  );

 /*
  Reparent the cursor whenever Shopify opens,
  closes, inserts, or removes a native dialog.
*/
const observer =
  new MutationObserver(
    syncCursorHost
  );

observer.observe(
  document.documentElement,
  {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  }
);

document.addEventListener(
  'toggle',
  syncCursorHost,
  true
);

document.addEventListener(
  'close',
  syncCursorHost,
  true
);

document.addEventListener(
  'shopify:section:load',
  syncCursorHost
);

document.addEventListener(
  'shopify:section:reorder',
  syncCursorHost
);

document.documentElement.classList.add(
  'isekaid-rune-cursor-ready'
);

syncCursorHost();

  const disableCursor = () => {
    document.documentElement.classList.remove(
      'isekaid-rune-cursor-ready'
    );

    observer.disconnect();
    style.remove();
    cursor.remove();
  };

  finePointer.addEventListener?.(
    'change',
    (event) => {
      if (!event.matches) {
        disableCursor();
      }
    }
  );

  reducedMotion.addEventListener?.(
    'change',
    (event) => {
      if (event.matches) {
        disableCursor();
      }
    }
  );
})();